export default __webpack_public_path__ + "static/per-marker-customisation-fbe344e974a63fbcf98e6ffbc0881a18.png";